import { GlobalState } from '@store';

import { IState } from '@store/reducers/locations';

export const getCenters = (state: GlobalState): IState['centers'] => state.locations.centers;
export const getCurrentLocation = (state: GlobalState): IState['currentLocation'] => state.locations.currentLocation;

export const getLocationNameLocative =
  (locationId: number) =>
  (state: GlobalState): IState['currentLocation']['nameLocative'] =>
    getCenters(state).find(({ id }) => id === locationId)?.nameLocative;
